import React from "react";
import FoundationVariables from "../../Styles/Wakakuu/variables/_foundation.scss"
import useParseCssList from "./useParseCssList"
import useWindowSize from "./useWindowSize"

const breakpoints = useParseCssList(FoundationVariables.breakpoints);
const mediumBreakpoint = parseInt(breakpoints.medium.replace("px", ""))

export default function useIsMobile(breakpoint) {
  if(breakpoint) {
    breakpoint = parseInt(breakpoints[breakpoint].replace("px", ""))
  }else{
    breakpoint = mediumBreakpoint
  }
  const [windowWidth] = useWindowSize()
  const [isMobile, setIsMobile] = React.useState(windowWidth <= breakpoint-1)
  React.useEffect(() => {
      setIsMobile(windowWidth <= breakpoint-1)
  }, [windowWidth])
  return isMobile
}